(() => {
  const selectors = {
    community: '.js-community',
    communitySwiper: '.js-community .swiper',
    communitySlide: '.community__card',
    communitySliderPagination: '.js-community-pagination',
  }

  const communityElement = document.querySelector(selectors.community);
  if (!communityElement) return;

  const slidesCount = communityElement.querySelectorAll(selectors.communitySlide).length;
  if (slidesCount <= 1) {
    communityElement.classList.add('community--single-slide');
    return;
  }

  const {
    slidesPerView,
    slidesPerViewMobile,
    spaceBetween
  } = communityElement.dataset;

  if (slidesCount < parseFloat(slidesPerView)) {
    communityElement.classList.add('community--max-width');
  }

  const communitySwiper = new Swiper(selectors.communitySwiper, {
    watchOverflow: true,
    allowTouchMove: slidesCount > 1,
    slidesPerView: slidesCount < parseFloat(slidesPerViewMobile) ? slidesCount : parseFloat(slidesPerViewMobile) || 1,
    spaceBetween: parseFloat(spaceBetween) || 8,
    breakpoints: {
      768: {
        slidesPerView: slidesCount < parseFloat(slidesPerView) ? slidesCount : parseFloat(slidesPerView) || 1.3,
        spaceBetween: parseFloat(spaceBetween) || 8,
      }
    },
    pagination: {
      el: selectors.communitySliderPagination,
      clickable: true,
    },
  });

  const container = communityElement.querySelector('.community__container');

  const updateGradientVisibility = () => {
    if (!container) return;

    const isAtBeginning = communitySwiper.isBeginning;
    const isAtEnd = communitySwiper.isEnd;

    if (isAtBeginning) {
      container.style.setProperty('--show-left-gradient', '0');
    } else {
      container.style.setProperty('--show-left-gradient', '1');
    }

    if (isAtEnd) {
      container.style.setProperty('--show-right-gradient', '0');
    } else {
      container.style.setProperty('--show-right-gradient', '1');
    }
  };

  communitySwiper.on('slideChange', updateGradientVisibility);
  communitySwiper.on('slideChangeTransitionEnd', updateGradientVisibility);

  updateGradientVisibility();
})();
